import * as stylex from '@stylexjs/stylex';
import '~styles/theme.stylex';
import { colors, font, radius, shadow } from '~styles/theme.stylex';

// Matches the app's ContinueWithButton: full width, icon pinned left, label
// centered, buttonRadius=12, slight elevation.
export const styles = {
  button: {
    position: "x1n2onr6",
    width: "xh8yej3",
    display: "x78zum5",
    alignItems: "x6s0dn4",
    justifyContent: "xl56j7k",
    paddingBlock: "xo0yzjp",
    paddingTop: null,
    paddingBottom: null,
    paddingInline: "x1mf6lh3",
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    backgroundColor: "x1f0ztbi",
    color: "x84ig5d",
    borderStyle: "xng3xce",
    borderInlineStyle: null,
    borderInlineStartStyle: null,
    borderLeftStyle: null,
    borderInlineEndStyle: null,
    borderRightStyle: null,
    borderBlockStyle: null,
    borderTopStyle: null,
    borderBottomStyle: null,
    borderRadius: "xnwxjz0",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    boxShadow: "x13g88js",
    fontFamily: "x1qh5nd4",
    fontSize: "x1jchvi3",
    fontWeight: "xlr2uoh",
    cursor: "x1ypdohk",
    opacity: "xfqoyci",
    $$css: true
  },
  icon: {
    position: "x10l6tqk",
    left: "x1pemb1n",
    insetInlineStart: null,
    insetInlineEnd: null,
    $$css: true
  }
};